import * as React from "react";
import Component from "../../AbstractComponent";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";

export default class Breadcrumbs extends Component {
  constructor(public props) {
    super(props);
  }

  public normalizeUrlTitle = (url) => {
    if (url.includes("app/units")) {
      return this.trans("breadcrumbs-label-units");
    }

    if (url.includes("app/unit") && url.includes("default-charge-templates")) {
      return this.trans("breadcrumbs-label-default-unit-prices");
    }

    if (url.includes("app/unit") && url.includes("pay-charges")) {
      return this.trans("breadcrumbs-label-unit-charges");
    }

    if (url.includes("app/properties")) {
      return this.trans("breadcrumbs-label-properties");
    }

    if (url.includes("app/contacts/companies")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-contacts").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-contact-companies").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/contacts/persons")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-contacts").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-contact-persons").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/companies")) {
      return this.trans("breadcrumbs-label-companies");
    }

    if (url.includes("/app/finance/payment")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance-payments").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("/app/finance/agency-statements")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans(
              "breadcrumbs-label-reports-agencystatement"
            ).toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("/app/finance/charge")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance-charges").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("/app/finance/transaction")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans(
              "breadcrumbs-label-finance-banktransaction"
            ).toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/finance/agencybalance")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans(
              "breadcrumbs-label-finance-agencybalance"
            ).toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("/app/finance/reports")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance-reports").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("/app/finance/invoices")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance-invoices").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("/app/finance/savings")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance-savings").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/finance/owner-statements") && /[0-9]/.test(url)) {
      const id = parseInt(url.replace(/\D+/g, ""));
      const company = this.props.app.companies.filter(
        (company: CompanyInterface) => company.id === id
      )[0];

      if (company) {
        return company.displayName;
      }
    }

    if (url.includes("app/finance/owner-statements")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance-statements").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/reports/agency-statements")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-reports").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans(
              "breadcrumbs-label-reports-agencystatement"
            ).toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/reports/booklist")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-reports").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-reports-booklist").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/reports/paylist")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-reports").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-reports-paylist").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/reports/overview")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-reports").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-reports-overview").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/reports/balance")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-reports").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-reports-balance").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/reports") && !/[0-9]/.test(url)) {
      return this.trans("breadcrumbs-label-reports");
    }

    if (url.includes("agency-statement/update")) {
      return this.trans("breadcrumbs-label-agency-statement");
    }

    if (url.includes("owner-statement/update") && /[0-9]/.test(url)) {
      const statementId = parseInt(url.match(/(\d+)/));
      const financialStatementData = this.props.app.fetchedStatementDatas.find(
        (statementData) => statementData?.id === statementId
      );

      if (financialStatementData) {
        return this.formatter.monthYearFormatDate(
          financialStatementData?.firstDate
        );
      }

      return this.trans("breadcrumbs-label-owner-statement");
    }

    if (url.includes("app/settings")) {
      return this.trans("breadcrumbs-label-settings");
    }

    if (url.includes("app/dashboard/overview")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard-overview").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/dashboard/tasks")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard-tasks").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/dashboard/activities")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard-activities").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/dashboard/statements")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard-statements").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/dashboard/contracts")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard-contracts").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/dashboard/notifications")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans(
              "breadcrumbs-label-dashboard-notifications"
            ).toUpperCase()}
          </span>
        </div>
      );
    }

    // if (url.includes("app/dashboard/receivables")) {
    //   return <div className="breadcrumbs-like-component"><span style={{padding: "0px 15px 0px 5px", display: "flex", alignItems: "center"}}>{this.trans("breadcrumbs-label-dashboard").toUpperCase()}</span>{">"}<span style={{padding: "0px 5px 0 15px", display: "flex", alignItems: "center"}}>{this.trans("breadcrumbs-label-dashboard-receivables").toUpperCase()}</span></div>;
    // }

    // if (url.includes("app/dashboard/payables")) {
    //   return <div className="breadcrumbs-like-component"><span style={{padding: "0px 15px 0px 5px", display: "flex", alignItems: "center"}}>{this.trans("breadcrumbs-label-dashboard").toUpperCase()}</span>{">"}<span style={{padding: "0px 5px 0 15px", display: "flex", alignItems: "center"}}>{this.trans("breadcrumbs-label-dashboard-payables").toUpperCase()}</span></div>;
    // }
    if (url.includes("app/dashboard/charges")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-finance-charges").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/dashboard/unused")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard-unused").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/dashboard/notes")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard-notes").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("app/dashboard/messages")) {
      return (
        <div className="breadcrumbs-like-component">
          <span
            style={{
              padding: "0px 15px 0px 5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard").toUpperCase()}
          </span>
          {">"}
          <span
            style={{
              padding: "0px 5px 0 15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.trans("breadcrumbs-label-dashboard-messages").toUpperCase()}
          </span>
        </div>
      );
    }

    if (url.includes("property") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-property");
    }

    if (url.includes("unit") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-unit");
    }

    if (url.includes("contract") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-contract");
    }

    if (url.includes("contract") && url.includes("extend")) {
      return this.trans("breadcrumbs-label-renew-contract");
    }

    if (url.includes("person") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-person");
    }

    if (url.includes("tenant") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-tenant");
    }

    if (url.includes("caretaker") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-manager");
    }

    if (url.includes("executor") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-executor");
    }

    if (url.includes("company") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-company");
    }

    if (url.includes("owner") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-owner");
    }

    if (url.includes("user") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-user");
    }

    if (url.includes("activity-template") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-activity-template");
    }

    if (url.includes("activity/create")) {
      return this.trans("breadcrumbs-label-new-activity");
    }

    if (url.includes("charge") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-charge");
    }

    if (url.includes("payment") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-payment");
    }

    if (url.includes("charge") && url.includes("link")) {
      return this.trans("breadcrumbs-label-pay-charge");
    }

    if (url.includes("payment") && url.includes("link")) {
      return this.trans("breadcrumbs-label-use-payment");
    }

    if (url.includes("property") && url.includes("update")) {
      return this.trans("breadcrumbs-label-property");
    }

    if (url.includes("unit") && url.includes("update")) {
      return this.trans("breadcrumbs-label-unit");
    }

    if (url.includes("contract") && url.includes("update")) {
      return this.trans("breadcrumbs-label-contract");
    }

    if (url.includes("person") && url.includes("update")) {
      const id = parseInt(url.replace(/\D+/g, ""));
      const person: PersonInterface = this.props.app.persons.filter(
        (person: PersonInterface) => person.id === id
      )[0];

      return person ? person.roleDisplayName() : this.trans("label-person");
    }

    if (url.includes("tenant") && url.includes("update")) {
      return this.trans("breadcrumbs-label-tenant");
    }

    if (url.includes("executor") && url.includes("update")) {
      return this.trans("breadcrumbs-label-executor");
    }

    if (url.includes("caretaker") && url.includes("update")) {
      return this.trans("breadcrumbs-label-manager");
    }

    if (url.includes("company") && url.includes("update")) {
      return this.trans("breadcrumbs-label-company");
    }

    if (url.includes("owner") && url.includes("update")) {
      return this.trans("breadcrumbs-label-owner");
    }

    if (url.includes("agency") && url.includes("update")) {
      return this.trans("breadcrumbs-label-agency");
    }

    if (url.includes("user") && url.includes("update")) {
      return this.trans("breadcrumbs-label-user");
    }

    if (url.includes("activity-template") && url.includes("update")) {
      return this.trans("breadcrumbs-label-activity-template");
    }

    if (url.includes("activity/update")) {
      return this.trans("breadcrumbs-label-activity");
    }

    if (url.includes("charge") && url.includes("update")) {
      return this.trans("breadcrumbs-label-charge");
    }

    if (url.includes("payment") && url.includes("update")) {
      return this.trans("breadcrumbs-label-payment");
    }

    if (url.includes("/app/charge") && url.includes("settle")) {
      return this.trans("breadcrumbs-label-charge-settle");
    }

    if (url.includes("/app/payment") && url.includes("settle")) {
      return this.trans("breadcrumbs-label-payment-settle");
    }

    if (url.includes("notification") && url.includes("update")) {
      return this.trans("breadcrumbs-label-notification");
    }

    if (url.includes("transaction-file") && url.includes("bank-transaction")) {
      return this.trans("breadcrumbs-label-bank-transaction");
    }

    if (url.includes("transaction-file")) {
      return this.trans("breadcrumbs-label-transaction-file");
    }

    if (url.includes("/app/mails")) {
      return this.trans("breadcrumbs-label-mails");
    }

    if (url.includes("/app/new")) {
      return this.trans("breadcrumbs-label-new");
    }

    if (url.includes("task") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-task");
    }

    if (url.includes("task") && url.includes("update")) {
      return this.trans("breadcrumbs-label-task");
    }

    if (url.includes("note") && url.includes("create")) {
      return this.trans("breadcrumbs-label-new-note");
    }

    if (url.includes("note") && url.includes("update")) {
      return this.trans("breadcrumbs-label-note");
    }

    if (url.includes("email") && url.includes("send")) {
      return this.trans("breadcrumbs-label-send-email");
    }

    if (url.includes("link") && url.includes("send")) {
      return this.trans("breadcrumbs-label-send-email");
    }

    if (url.includes("conversation") && url.includes("update")) {
      return this.trans("breadcrumbs-label-conversation");
    }

    if (url.includes("agreement") && url.includes("update")) {
      return this.trans("breadcrumbs-label-agreement");
    }

    // coach
    if (url.includes("/app/coach/new-bill-settlement")) {
      return this.trans("breadcrumbs-label-new-bill-settlement");
      // return this.trans("breadcrumbs-label-agreement");
    }

    return url;
  };

  public render = () => {
    let history = [...this.props.app.breadcrumbs];

    // breadcrumbs should have limit
    const maxElements = 7;
    let breadcrumbsNumber =
      history && history.length > maxElements ? maxElements : history.length;
    history.splice(breadcrumbsNumber);
    history.reverse();

    let breadcrumbs = [];
    breadcrumbs = history.map((url) => {
      // should do this check because we do not want to change breadcrumbs when clicking tabs
      if (
        this.normalizeUrlTitle(url) === this.trans("title-contacts") &&
        breadcrumbs.includes(this.trans("title-contacts"))
      ) {
        return;
      }

      if (
        this.normalizeUrlTitle(url) === this.trans("title-companies") &&
        breadcrumbs.includes(this.trans("title-companies"))
      ) {
        return;
      }

      if (
        this.normalizeUrlTitle(url) === this.trans("title-finance") &&
        breadcrumbs.includes(this.trans("title-finance"))
      ) {
        return;
      }

      if (
        this.normalizeUrlTitle(url) === this.trans("title-reports") &&
        breadcrumbs.includes(this.trans("title-reports"))
      ) {
        return;
      }

      if (
        this.normalizeUrlTitle(url) === this.trans("title-settings") &&
        breadcrumbs.includes(this.trans("title-settings"))
      ) {
        return;
      }

      if (
        this.normalizeUrlTitle(url) === this.trans("title-dashboard") &&
        breadcrumbs.includes(this.trans("title-dashboard"))
      ) {
        return;
      }

      return this.normalizeUrlTitle(url);
    });

    return (
      <div
        className="breadcrumbs"
        style={{
          height: "30px",
          width: "100%",
          backgroundColor: "rgb(232, 232, 232)",
          color: "#6d6d6d",
          position: "fixed" as "fixed",
          top: "56px",
          left: "66px",
          zIndex: 100,
          padding: "0px 20px",
          display: "flex",
          fontSize: "16px",
        }}
      >
        {breadcrumbs &&
          breadcrumbs.map((url, index) => {
            return (
              <div
                className="breadcrumb-item"
                key={`breadcrumb-item-${url}-${index}`}
                style={{
                  padding: "0px 15px",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  this.redirectFewStepsBack(breadcrumbs.length - index - 1);
                }}
              >
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight:
                      index !== breadcrumbs.length - 1 ? "normal" : "bold",
                  }}
                >
                  {url && url.type && url.type === "div"
                    ? url
                    : url.toUpperCase()}
                </div>
                {index !== breadcrumbs.length - 1 && (
                  <div
                    style={{
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      position: "relative" as "relative",
                      left: "15px",
                    }}
                  >
                    {">"}
                  </div>
                )}
              </div>
            );
          })}
      </div>
    );
  };
}
